import { VALID_PATH_SEGMENTS } from "./constants";

const validPath = () =>
  !!window.location.pathname
    .split("/")
    .find(pathSegment =>
      VALID_PATH_SEGMENTS.find(path => !pathSegment.indexOf(path))
    );

export default validPath;
